import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "深圳市智聚云创科技有限公司", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: { background: '#fff', padding: '24px', minHeight: '280px' } }, [
  /*#__PURE__*/_createTextVNode(" 阿斯顿业务管理系统项目入口: "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://www.szzjyc.cn:8090/login" }, "进入")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "粤ICP备2023110130号", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { style: {"padding":"0 50px"} }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, { style: {"text-align":"center"} }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}